// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsThemesTemplate_heading__UbJdK"};